import { useRelationshipsSearch } from '../RelationshipsSearchProvider';

/**
 * Wrapper for useRelationshipsSearch that returns undefined instead of throwing when not in a relationships search context. 
 * This allows components to work in both modal and non-modal contexts without conditional hook calls.
 */
export function useRelationshipsSearchSafe() {
  try {
    return useRelationshipsSearch();
  } catch {
    return undefined;
  }
}
